import { apiPaths, getApiPath, httpStatus } from '../../../constants'
import { Api } from '../../../middlewares'
import { Logger, LoggerTypes } from '../../../utils'

// -- GET
export const GET_SCENARIO_LOCATIONS_SUCCESS = 'GET_SCENARIO_LOCATIONS_SUCCESS'
export const GET_SCENARIO_LOCATIONS_FAILURE = 'GET_SCENARIO_LOCATIONS_FAILURE'

// -- CREATE
export const CREATE_SCENARIO_LOCATION_SUCCESS = 'CREATE_SCENARIO_LOCATION_SUCCESS'
export const CREATE_SCENARIO_LOCATION_FAILURE = 'CREATE_SCENARIO_LOCATION_FAILURE'

// -- UPDATE
export const UPDATE_SCENARIO_LOCATION_SUCCESS = 'UPDATE_SCENARIO_LOCATION_SUCCESS'
export const UPDATE_SCENARIO_LOCATION_FAILURE = 'UPDATE_SCENARIO_LOCATION_FAILURE'

// -- DELETE
export const DELETE_SCENARIO_LOCATION_SUCCESS = 'DELETE_SCENARIO_LOCATION_SUCCESS'
export const DELETE_SCENARIO_LOCATION_FAILURE = 'DELETE_SCENARIO_LOCATION_FAILURE'

// -- SEARCH
export const SEARCH_SCENARIO_LOCATIONS = 'SEARCH_SCENARIO_LOCATIONS'

// -----------------------------------------------------------------------------

/**
 * SEARCH for a scenario location attribute based on its name.
 *
 * @param {string} terms Text to be searched within the scenario location.
 * @returns {Promise<array<object>>}
 */
export const searchScenarioLocations = (terms) => async (dispatch) => {
  dispatch({
    type: SEARCH_SCENARIO_LOCATIONS,
    data: terms
  })
}

/**
 * GET the list of all the locations that belong to a specific scenario.
 *
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<array<object>>}
 */
export const getScenarioLocations = (pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_LOCATION_LIST, { pid, sid })
  const api = new Api(path)
  const result = await api.get()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] locationsActions.getScenarioLocations()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: GET_SCENARIO_LOCATIONS_SUCCESS,
      data: result.data.items || []
    })
  }
  return dispatch({
    type: GET_SCENARIO_LOCATIONS_FAILURE,
    data: result.data
  })
}

/**
 * CREATE a new scenario location attribute.
 *
 * @param {object} newLocation New location to be created.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {object}
 */
export const createScenarioLocation = (newLocation, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_LOCATION_CREATE, { pid, sid })
  const api = new Api(path)
  const result = await api.create(newLocation)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] locationsActions.createScenarioLocation()', { path, newLocation, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: CREATE_SCENARIO_LOCATION_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: CREATE_SCENARIO_LOCATION_FAILURE,
    data: result.data
  })
}

/**
 * UPDATE a specific scenario location attribute.
 *
 * @param {object} newLocation Location object that will replace the previous one.
 * @param {uuid} lid Scenario location ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const updateScenarioLocation = (newLocation, lid, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_LOCATION_UPDATE, { pid, sid, lid })
  const api = new Api(path)
  const result = await api.update(newLocation)

  Logger.trace(LoggerTypes.ACTION, '[ACTION] locationsActions.updateScenarioLocation()', { path, newLocation, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: UPDATE_SCENARIO_LOCATION_SUCCESS,
      data: result.data
    })
  }
  return dispatch({
    type: UPDATE_SCENARIO_LOCATION_FAILURE,
    data: result.data
  })
}

/**
 * DELETE a specific scenario location attribute.
 *
 * @param {uuid} lid Scenario location ID.
 * @param {uuid} pid Project ID.
 * @param {uuid} sid Scenario ID.
 * @returns {Promise<object>}
 */
export const deleteScenarioLocation = (lid, pid, sid) => async (dispatch) => {
  const path = getApiPath(apiPaths.SCENARIO_LOCATION_DELETE, { pid, sid, lid })
  const api = new Api(path)
  const result = await api.delete()

  Logger.trace(LoggerTypes.ACTION, '[ACTION] locationsActions.deleteScenarioLocation()', { path, result })

  if (result.status >= httpStatus.OK && result.status < httpStatus.AMBIGUOUS) {
    return dispatch({
      type: DELETE_SCENARIO_LOCATION_SUCCESS,
      data: lid
    })
  }

  return dispatch({
    type: DELETE_SCENARIO_LOCATION_FAILURE,
    data: result.data
  })
}
